<script>
  export let mode
  export let currentMode

  $: current = mode === currentMode

  function select() {
    currentMode = mode
  }
</script>

<button aria-current={current} disabled={current} on:click={select}
  >{mode}</button
>

<style>
  button {
    all: unset;
    box-sizing: border-box;

    font-size: var(--font-size-m);
    line-height: var(--line-height-m);

    height: calc(var(--line-height-m) * 1.5);

    background-color: var(--white);
    color: var(--grey);

    padding: 0 0.6em;

    white-space: nowrap;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: stretch;
    align-items: center;

    border: 1px solid var(--grey-light);
    border-left: 0;

    text-transform: capitalize;
  }

  button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
    border-left: 1px solid var(--grey-light);
  }

  button:last-child {
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  button[aria-current="true"] {
    color: var(--black);
  }

  button:not([disabled]) {
    cursor: pointer;
  }
</style>
